import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useBillingData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.BILLING_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/companyManage/lookup/isBilling`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useBillingData;
